<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-time</h2>
            <p class="demo-description">Time selector with up/down controls, manual typing, and optional vertical swipe.</p>

            <div class="demo-controls">
                <ion-button size="small" (click)="toggleDisabled()">
                    Disabled: {{ disabled }}
                </ion-button>
                <ion-button size="small" (click)="toggleSwipe()">
                    Swipe: {{ swipeEnabled }}
                </ion-button>
            </div>

            <div class="demo-section" [formGroup]="form">
                <ion-item lines="none">
                    <upp-time
                        formControlName="time"
                        title="Start time"
                        placeholder="HH:mm"
                        [step]="5"
                        [swipeEnabled]="swipeEnabled"
                        [swipeThreshold]="12"
                    ></upp-time>
                </ion-item>
                <p class="demo-label">Value: <strong>{{ form.get('time')?.value }}</strong></p>
            </div>
        </div>
    </upp-scrollable>
</div>
